const styles = {
  completed: 'bg-success-500/10 text-success-700',
  successful: 'bg-success-500/10 text-success-700',
  success: 'bg-success-500/10 text-success-700',
  processing: 'bg-warning-500/10 text-warning-700',
  pending: 'bg-warning-500/10 text-warning-700',
  unpaid: 'bg-warning-500/10 text-warning-700',
  paying: 'bg-warning-500/10 text-warning-700',
  'pending verification': 'bg-warning-500/10 text-warning-700',
  failed: 'bg-danger-500/10 text-danger-700',
  declined: 'bg-danger-500/10 text-danger-700',
  timeout: 'bg-secondary-500/10 text-secondary-700',
  cancelled: 'bg-secondary-500/10 text-secondary-700',
  close: 'bg-danger-500/10 text-danger-700',
  active: 'bg-success-500/10 text-success-700',
  inactive: 'bg-secondary-500/10 text-secondary-700',
  deactivated: 'bg-danger-500/10 text-danger-700',
  paid: 'bg-success-500/10 text-success-700',
};

// A payout's `unknown` counts as neither settled nor failed, so it must land on the neutral
// fallback rather than borrow either colour.
const fallback = 'bg-secondary-500/10 text-secondary-700';

const tones = {
  success: 'bg-success-500/10 text-success-700',
  warning: 'bg-warning-500/10 text-warning-700',
  danger: 'bg-danger-500/10 text-danger-700',
  secondary: fallback,
};

const labels = {
  timeout: 'Timed out',
};

const titleCase = (value) =>
  value.replace(/\w\S*/g, (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase());

const StatusPill = ({ status, tone, className = '' }) => {
  if (status === null || status === undefined || status === '') {
    return <span className={`badge ${fallback} ${className}`}>—</span>;
  }
  const raw = String(status);
  const key = raw.toLowerCase();
  const style = tones[tone] ?? styles[key] ?? fallback;
  return <span className={`badge ${style} ${className}`}>{labels[key] ?? titleCase(raw)}</span>;
};

export default StatusPill;
